// import { useEffect, useState } from 'react';

import { getRowFormatted, RowType } from './useTable';
// import { TimeWindowTabTypes } from '../types/TimeWindows';
// import { SelectorType } from '../../../types/Benchmark';

// const frequencyOptions: (SelectorType)[] = [{
//   label: 'Daily',
//   value: 'daily',
// }, {
//   label: 'Weekly',
//   value: 'weekly',
// }, {
//   label: 'Monthly',
//   value: 'monthly',
// }, {
//   label: 'Quarterly',
//   value: 'quarterly',
// }];

// function getFrequencyOption(option: any) {
//   return frequencyOptions.filter((item) => item.label === option);
// }

export const useTimeWindow = (props: any) => {
  // export const useTimeWindow = ({ fromDate, returnComponent, numberPeriods, frequency, isTimeWindowEnable}: TimeWindowTabTypes) => {
  // const [fromDateCurrentState, setFromDate] = useState<Date>(new Date());
  // const [returnComponenCurrenttState, setReturnComponent] = useState<string | null>(null);
  // const [numberPeriodsCurrentState, setNumberPeriods] = useState<string | null>(null);
  // const [frequencyCurrentState, setFrequency] = useState<(SelectorType)[] | []>([]);

  // useEffect(() => {
  //   setFromDate(fromDate ? new Date(fromDate) : new Date());
  //   setReturnComponent(returnComponent || null);
  //   setNumberPeriods(numberPeriods || null);
  //   setFrequency(getFrequencyOption(frequency || null));
  // }, [fromDate, returnComponent, numberPeriods, frequency]);

  // const handleFronmDateChange = (date: Date) => setFromDate(date);

  // const handleReturnComponentChange = (event: { target: { value: string; }; }) => setReturnComponent(event.target.value);

  // const handleNumberPeriodsChange = (event: { target: { value: string; }; }) => setNumberPeriods(event.target.value);

  // const handleFrequencyChange = (value: SelectorType) =>  setFrequency([value]);

  const tab = {
    // fromDate: fromDateCurrentState,
    // returnComponent: returnComponenCurrenttState,
    // numberPeriods: numberPeriodsCurrentState,
    // frequency: frequencyCurrentState[0]?.value,
    isTimeWindowEnable: props?.isTimeWindowEnable ?? false,
  };

  const getDataRow = (row: RowType) => getRowFormatted(row);

  return {
    // frequencyOptions,
    ...tab,
    tab,
    // frequency: frequencyCurrentState,
    // onFromDateChange: handleFronmDateChange,
    // onReturnComponentChange: handleReturnComponentChange,
    // onNumberPeriodsChange: handleNumberPeriodsChange,
    // onFrequencyChange: handleFrequencyChange,
    getDataRow,
  };
};
